import { EntityModel } from '@/interfaces'
import {
  ALL_CUSTOM_DATA_CONFIGS_QUERY,
  CREATE_CUSTOM_DATA_CONFIG_MUTATION,
  DELETE_CUSTOM_DATA_CONFIG_MUTATION,
  FORCE_DELETE_CUSTOM_DATA_CONFIG_MUTATION,
  SINGLE_CUSTOM_DATA_CONFIG_QUERY,
  UPDATE_CUSTOM_DATA_CONFIG_MUTATION,
} from './graphql'
import customBookingFormEntity from '@/entities/customBookingForm/entity'

const travelPricingCustomDataConfigModel: EntityModel = {
  name: 'customDataConfig',
  namePlural: 'customDataConfigs',
  uniqueName: 'travelPricingCustomDataConfig',
  uniqueNamePlural: 'travelPricingCustomDataConfigs',
  path: 'travel/pricing/custom_data_config',
  baseUrl: '/travel/pricing/custom_data_configs',
  translationPrefix: 'entities:travelPricingCustomDataConfig.',
  getDisplayName: (values: any) => {
    return 'CUSTOM DATA CONFIG'
  },
  gql: {
    getAll: ALL_CUSTOM_DATA_CONFIGS_QUERY,
    getSingle: SINGLE_CUSTOM_DATA_CONFIG_QUERY,
    create: CREATE_CUSTOM_DATA_CONFIG_MUTATION,
    update: UPDATE_CUSTOM_DATA_CONFIG_MUTATION,
    delete: DELETE_CUSTOM_DATA_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_CUSTOM_DATA_CONFIG_MUTATION,
  },
  attributes: {
    useTravellerForm: {
      name: 'useTravellerForm',
      label: 'entities:travelPricingCustomDataConfig.attributes.useTravellerForm.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    travellerForm: {
      name: 'travellerForm',
      label: 'entities:travelPricingCustomDataConfig.attributes.travellerForm.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return customBookingFormEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    useBookingForm: {
      name: 'useBookingForm',
      label: 'entities:travelPricingCustomDataConfig.attributes.useBookingForm.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    bookingForm: {
      name: 'bookingForm',
      label: 'entities:travelPricingCustomDataConfig.attributes.bookingForm.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return customBookingFormEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelPricingCustomDataConfigModel
